export default "__VITE_ASSET__lXUImNnj__"